<template>
    <v-col class="pa-0">
        <v-card :class="{'elevation-0': dialog}" class="round-card background-2">
            <v-card-title class="pa-3">
                <p class="pl-2 pl-xl-3">Attività Fatturazione Elettronica</p>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-text-field class="hidden-xs-only font-weight-regular" v-show="expand"
                    append-icon="search"
                    label="Cerca"
                    v-model="search"
                    clearable
                    hide-details
                    outlined dense
                ></v-text-field>
                <v-tooltip top>
					<template v-slot:activator="{ on }">							
                        <v-btn class="ml-3" @click="initialize()" :loading="loaderButton" v-on="on" icon>
                            <v-icon>refresh</v-icon>
                        </v-btn>
					</template>
                    <span>Refresh</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" @click="expand = !expand" icon>
                            <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
                        </v-btn>
                    </template>                    
                    <span>{{ expand ? 'Contrai' : 'Espandi' }}</span>
                </v-tooltip>
            </v-card-title>            
            <v-divider v-if="!dialog && expand"></v-divider>
		    <v-container class="py-0" fluid v-show="expand">
                <v-row class="ma-0">
				    <v-col cols="12" class="pa-3">
                        <v-text-field class="hidden-sm-and-up"
                            append-icon="search"
                            label="Cerca"
                            v-model="search"
                            clearable
                            hide-details
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
            <v-expand-transition>
                <v-container class="pa-0" fluid v-show="expand">
                    <v-data-iterator
                        :items="comments"
                        :options.sync="pagination"
                        :server-items-length="totalItems"
                        column
                        class="lg10">
                        <template v-slot:no-data>
                            <div class="text-center w100p">
                                <v-card class="background-2 fs12i py-0 mx-4" elevation="0">
                                    <v-card-text class="caption text-center pb-1 pt-10">Nessuna attività</v-card-text>
                                    <v-card-text class="text-center pt-1"></v-card-text>
                                </v-card>
                            </div>
                        </template>

                        <template v-slot:header>
                            <v-row class="ma-0">
                                <v-col cols="11" lg="11" offset-lg="1" class="comment pa-0">
                                    <v-timeline class="comment" dense clipped :class="{'mobile-timeline': $vuetify.breakpoint.mdAndDown}">
                                        <v-timeline-item
                                            fill-dot
                                            medium>
                                            <template v-slot:icon>
                                                <v-avatar dark class="primary--text" :size="38">
                                                    <v-icon>
                                                        mdi-bell-cog-outline
                                                    </v-icon>
                                                </v-avatar>
                                            </template>
                                        </v-timeline-item>
                                    </v-timeline>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:item="props">
                            <v-row class="ma-0">
                                <v-col cols="10" sm="11" lg="10" offset-lg="1" class="pa-0">
                                    <v-timeline dense clipped class="pt-0" :class="{'mobile-timeline': $vuetify.breakpoint.mdAndDown}">
                                        <v-slide-x-transition group>
                                            <v-timeline-item :key="props.item.id"
                                                class="ma-0 pb-0"
                                                color="transparent"
                                                small>
                                                <template v-slot:icon>
                                                    <v-avatar dark :size="18">
                                                        <v-icon>
                                                            mdi-bell-cog-outline
                                                        </v-icon>
                                                    </v-avatar>
                                                </template>
                                                <v-row class="ma-0" justify="space-between">

                                                    <template>
                                                        <template v-if="$vuetify.breakpoint.mdAndUp">
                                                            <v-col cols="9" class="fs12" style="margin: auto; margin-left: 0" v-html="props.item.text"></v-col>
                                                            <v-col cols="3" class="capitalize fs11 grey--text mr-0 text-right" style="margin: auto">{{ formatCreateDate(props.item.date) }}</v-col>
                                                        </template>
                                                        <template v-else>
                                                            <v-col cols="9" class="fs11 pa-0 py-1" style="margin: auto; margin-left: 0" v-html="props.item.text"></v-col>
                                                            <v-col cols="3" class="capitalize fs10 grey--text pa-0 mr-0 text-right" style="margin: auto" v-html="formatSmallCreateDate(props.item.date)"></v-col>
                                                        </template>
                                                    </template>
                                                </v-row>
                                            </v-timeline-item>
                                        </v-slide-x-transition>
                                    </v-timeline>
                                </v-col>
                            </v-row>
                        </template>

                        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
                            Da {{ pageStart }} a {{ pageStop }} di {{ itemsLength }}
                        </template>
                    </v-data-iterator>
                    <v-divider v-if=dialog></v-divider>
                </v-container>
            </v-expand-transition>
        </v-card>
    </v-col>
</template>

<script>
import EditorMention from '@/components/common/EditorMention'

export default {
	name: 'edocument-notifications',
	components: {
		EditorMention,
	},
	props: {
		modelClass: String,
		modelId: Number,
		dialog: Boolean,
	},

	data() {
		return {
			comments: [],
			input: '',
			search: '',
			loaderButton: false,
			pagination: {'itemsPerPage': 5},
			totalItems: 0,
			debounceUnwatch: {},
			textInEdit: null,
            commentId: null,
            expand: true,
		}
	},

	watch: {
		pagination: {
			handler(newValue, oldValue) {
				if(newValue.totalItems == oldValue.totalItems){
					this.initialize()
				}
			},
			deep: true,
		}
	},

	computed: {
		formatCreateDate(date) {
			return (date) => {
				return moment(date).format('LLLL')
			}
		},

		formatSmallCreateDate(date) {
			return (date) => {
				return moment(date).format('DD/MM/YY <br> H:m')
			}
		},

		isErasable(erasable) {
			return (erasable) => {
				return erasable == 1 ? true : false
			}
		},

		isEditable(editable) {
			return (editable) => {
				return editable == 1 ? true : false
			}
		}

	},

	methods: {
		comment() {
			if(this.input) {

				let data = {
					text: this.input,
					document_id: this.modelId,
				}

				this.axios.post('/edocumentnotifications', data).then(response => {
					// get body data
					this.initialize()
					this.input = ''
					this.$eventBusUtility.$emit('inputEmpty')

				}, response => {
					// error callback
				})
			}
		},

		initialize() {
			this.loaderButton = true
			let dataObject = {
				page: this.pagination.page,
				per_page: this.pagination.itemsPerPage,
				document_id: this.modelId,
				model_class: this.modelClass,
                filter: this.search,
                sortBy: ['edocumentnotifications.date'],
                sortDesc: [true],
			}
                
			this.axios.post('/edocumentnotifications-filters', dataObject).then(response => {
				// get body data
				this.comments = response.data.data.data
				this.totalItems = response.data.data.total
				setTimeout(() => {this.loaderButton = false}, 500)
                    
			}, response => {
				// error callback
			})
		}
	},

	created() {
		this.debounceUnwatch = this.$watch('search', _.debounce(this.initialize, 700))

        this.expand = !this.$store.getters.checkSettings('compact_viewing')        
	},
}
</script>

<style>
    .v-timeline {
        padding-top: 8px !important;
        position: relative;
    }

    .v-timeline:hover {
        background: rgba(0,0,0,0.06)
    }

    .comment .v-timeline:before {
        top: 12px;
        height: 65px;
    }

    .mobile-timeline > span > div > .v-timeline-item__body {
        max-width: calc(100% - 46px) !important;
    }

    .mobile-timeline > div > .v-timeline-item__body {
        max-width: calc(100% - 46px) !important;
    }
    .v-timeline:hover {
        background: transparent;
    }    
    .ql-mention-list-container {
        z-index: 999;
    }
</style>
